<app-stages [stages]="stages" currentStage="Podmiot zlecający przejazd"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)='submitAndGoNext()'>
    <div class="row">
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"orderingEntityName" as controlName'>
          <label [for]='controlName'>
            Nazwa *
          </label>
          <input
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu nazwę'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"orderingEntityPostalCode" as controlName'>
          <label [for]='controlName'>
            Kod pocztowy *
          </label>
          <input
            mask='00-000'
            [dropSpecialCharacters]='false'
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu kod pocztowy'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"orderingEntityPostOffice" as controlName'>
          <label [for]='controlName'>
            Poczta *
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu pocztę'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"orderingEntityCity" as controlName'>
          <label [for]='controlName'>
            Miejscowość *
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu miejscowość'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"orderingEntityStreet" as controlName'>
          <label [for]='controlName'>
            Ulica
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu nazwę ulicy'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-2'>
        <div class='form-group' *ngIf='"orderingEntityHouseNumber" as controlName'>
          <label [for]='controlName'>
            Nr domu *
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu nr domu'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-2'>
        <div class='form-group' *ngIf='"orderingEntityApartmentNumber" as controlName'>
          <label [for]='controlName'>
            Nr mieszkania
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu nr mieszkania'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
  </form>
  <div class='application-actions'>
    <button
      type='button'
      class='btn btn-secondary'
      (click)='onCancel()'>
      <span>
        Wstecz
      </span>
    </button>
    <button
      type='button'
      class='btn btn-primary'
      (click)='submitAndGoNext()'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
